<template>
    <el-drawer
            :title="formData.id ? '编辑奖品' : '添加奖品'"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="600px"
            @close="close"
        >
            <div class="drawer-content">
                <el-form
                    :model="formData"
                    :rules="rules"
                    ref="formData"
                    label-position="top"
                    size="medium"
                >
                    <el-form-item prop="name" label="奖品名称:">
                        <el-input v-model="formData.name" placeholder="请输入奖品名称" maxlength="15"></el-input>
                    </el-form-item>
                    <el-form-item prop="type" label="奖品内容:">
                        <el-radio-group v-model="formData.type">
                            <el-radio :label="1">无</el-radio>
                            <el-radio :label="2">优惠券</el-radio>
                            <el-radio :label="3">普通奖品</el-radio>
							<el-radio :label="4">演出赠票</el-radio>
                        </el-radio-group>
                    </el-form-item>
					<el-form-item prop="collectionType" label="信息收集类型:" v-if="formData.type == 3">
						<el-radio-group v-model="formData.collectionType">
							<el-radio :label="1">地址</el-radio>
							<el-radio :label="2">实名</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="collectionType" label="信息收集类型:" v-if="formData.type == 4">						
						<el-checkbox v-model="formData.collectionType" :true-label="2" :false-label="0">实名</el-checkbox>
					</el-form-item>					
                    <el-form-item v-if="formData.type == 2" prop="couponRuleId" label="优惠券:">
                        <el-select 
                            v-model="formData.couponRuleId" 
                            filterable
                            remote
                            :remote-method="searchCoupon"
                            multiple
                            :loading="couponLoading"
                            placeholder="请输入优惠券ID"
                            value-key="id"
                            >
                            <el-option v-for="item in couponList" :key="item.id" :value="(item.id).toString()" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
					<el-card v-if="formData.type == 4">
						
						<el-form-item label="绑定演出赠票：">
						    <el-input placeholder="输入演出ID查找赠票,多个ID用逗号分隔" v-model="sActivityIds">
						        <el-button slot="append" icon="el-icon-search" @click="searchActivity()">查找演出赠票</el-button>
						    </el-input>
						    <el-table class="MT10" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading">
						        <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
						        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
						        <el-table-column label="选择赠票">
						            <template slot-scope="scope">
						                <el-select v-model="scope.row.ids" placeholder="所有票品可用" multiple clearable>
						                    <el-option-group v-for="g in scope.row.sessions" :key="g.id" :label="g.name">
						                        <el-option v-for="item in g.tickets" :key="item.id"
						                            :label="`${g.name} - ${item.name}`" :value="item.id">
						                            {{item.name}}
						                        </el-option>
						                    </el-option-group>
						                </el-select>
						            </template>
						        </el-table-column>
						        <el-table-column label="操作" width="80">
						            <template slot-scope="scope">
						                <el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
						            </template>
						        </el-table-column>
						    </el-table>
						</el-form-item>
					</el-card>
                    <el-form-item prop="totalNum" label="奖品库存:">
                        <el-input-number style="width:100%" v-model="formData.totalNum" :precision="0" controls-position="right" :min="1" :max="99999999" :disabled="formData.id ? true : false"></el-input-number>
                    </el-form-item>
                    <el-form-item prop="showContent" label="奖品提示文案:">
                        <el-input v-model="formData.showContent" placeholder="请输入奖品提示文案" maxlength="30" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item prop="pic">
						<span slot="label">奖品图片: </span>
                        <image-upload 
                            :url.sync="formData.pic" 
                            :urlFull.sync="formData.pic" 
                        >
                        </image-upload>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                    >确定</el-button
                >
            </div>
    </el-drawer>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    name: "",
    type: 1,
    totalNum: 1,
    couponRuleId: [],
    activityId: "",
    showContent: "",
    pic: "",
	collectionType:0
}
export default {
    components:{
        ImageUpload
    },
    data(){
        return{
            drawerShow: false,
            formData:{
                ...defaultFormData
            },
            btnLoading:false,
            rules: {
                name: [{ required: true, message: "请输入名称" }],
                type: [{ required: true, message: "请选择奖品内容" }],
                totalNum:[{ required: true, message: "请输入奖品库存" }],
                couponRuleId:[{ required: true, message: "请选择优惠券" }],
				collectionType:[{ required: true, message: "请选择信息收集类型" }],
            },
            couponList: [],
            couponLoading: false,
			
			sActivityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			ticketIds:[]
        }
    },
    methods:{
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
			this.sActivityList = []
			this.sActivityIds =''
			this.btnLoading = false;
        },
        show(data){
			this.sActivityList = []
            if(data){
				
                this.formData = {
                    ...defaultFormData,
                    ...data,
                }
                if(data.couponRuleId && data.type == 2){
                    this.searchCoupon(data.couponRuleId);
                    this.formData.couponRuleId = data.couponRuleId.split(',');
                }
				
				if( data.couponRuleId && data.type == 4 ){
					let _sActivityIds = [];
					if (data.busActivityIds) {
					    const _ids = data.busActivityIds.split(',');
					    _sActivityIds = _sActivityIds.concat(_ids);
					}
					this.sActivityIds = _sActivityIds.toString();
					if (this.sActivityIds) {
					    this.searchActivity(() => {
					        this.$nextTick(() => {
					            const _ticketIds = this.formData.couponRuleId.split(',') || [];
					            this.sActivityList.map(item => {
					                item.sessions.map(s => {
					                    _ticketIds.map(t => {
					                        if (s.tickets.find(t1 => t1.id == t)) {
					                            if (item.ids) {
					                                item.ids.push(t);
					                            } else {
					                                item.ids = [t]
					                            }
					                        }
					                    })
					                })
					            })
					        })
					    });
					}
				}
				
            }
            this.drawerShow = true;
        },
		//搜索演出
		async searchActivity(callback) {
		    if (this.sActivityIds) {
		        this.sActivityLoading = true;
		
		        this.sActivityIds = this.sActivityIds.replace(/，/g, ',');
		
		        let _sActivityIds = this.sActivityIds.split(',');
		        _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));
		
		        const res = await this.$request({
		            url: '/lottery/prize/parsingPresentTicket',
		            method: 'post',
		            data: {
						activityIds:_sActivityIds,
						ticketIds:this.ticketIds
					}
		        }).catch(() => {
		            return { data: { state: '0', msg: '请求错误' } };
		        }).finally(() => {
		            this.sActivityLoading = false;
		        });
		
		        const { state, msg, result } = res.data;
		
		        if (state != 1) {
		            return this.$message.error(msg || '请求失败');
		
		        } else {
		            if (result && result.length > 0) {
		
		                result.map(item => {
		                    if (!this.sActivityList.find(v => v.id == item.id)) {
		                        this.sActivityList.push(item)
		                    }
		                })
		
		                callback && callback();
		
		            } else {
		                this.$message.error(msg || '此演出没有赠票');
		            }
		        }
		    }
		},
		//删除演出
		delActivity(id) {
		    this.sActivityList = this.sActivityList.filter(v => v.id != id);
		},
        //表单提交
        submitForm() {
			
            this.$refs["formData"].validate((valid) => {
                if (valid) {					
					let _activityIds = [];
					let _businessActivityIds = [];
					let _ticketIds = [];
					this.sActivityList.map(item => {
					    if(!item.ids || item.ids.length < 1){
					        _activityIds.push(item.id);
					    }else{
					        _businessActivityIds.push(item.id);
					        _ticketIds = _ticketIds.concat(item.ids);
					    }
					})					
					if( this.formData.type == 4 && _ticketIds == ''){
						return this.$message.error('请为奖品绑定演出赠票！');
					}
					if( this.formData.type != 1 && this.formData.pic == ''){
						return this.$message.error('请上传奖品图片！');
					}
					this.btnLoading = true;
                    this.$request({
                        url: "/lottery/prize/edit",
                        data: {
                            ...this.formData,
                            couponRuleId: this.formData.type == 2 ? this.formData.couponRuleId.toString() : _ticketIds.toString(),
							collectionType : this.formData.type == 1 || this.formData.type == 2 || (  this.formData.type ==  4 && this.formData.collectionType != 2 ) ? 0 :this.formData.collectionType
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate',result);
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
							
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        searchCoupon(query){
            if(query !== ""){
                this.couponLoading = true;
                this.$request({
                    url: "/lottery/prize/parsingCouponRule",
                    params: {
                        couponRuleId: query,
                        // couponRuleType: this.formData.type
                    },
                    method: "post",
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1) {
                            this.couponList = result ? [...result] : [];
                        } else {
                            this.couponList = [];
                            this.$message.error(msg || "查询失败,请重试");
                        }
                    })
                    .catch(() => {
                        this.couponList = [];
                        this.$message.error("查询失败,请重试");
                    })
                    .finally(() => {
                        this.couponLoading = false;
                    });
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>